import React, { useState, useEffect } from "react";
import Loader from "../Common/Loader";
import HeadToHeadService from "../../services/HeadToHeadService";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
const ShowAllTypeH2H = () => {
  const [isLoading, setIsLoading] = useState(false);
  const param = useParams();
  const [data, setData] = useState([]);
  const [roundDetails, setRoundDetails] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    if (param.type) {
      HeadToHeadService.showGroupHeadToHeadRound(
        param.type,
        param.roundId
      ).then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setData(res.h2hData);
        }
      });
    } else {
      HeadToHeadService.showHeadToHeadRound(param.roundId).then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setData(res.data);
          setRoundDetails(res.roundDetails);
        }
      });
    }
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Head-2-Head</h2>
            </div>
            <div className="tab-content">
              <div className="searchfilter">
                Round {roundDetails?.round},{" "}
                {moment(roundDetails?.start_date).format("D.MM.YYYY")}{" "}
                {moment(roundDetails?.start_time).format("h:mm A")}
                <div className="dropdown">
                  <Link className="dropdown-toggle" to={"/h2h"}>
                    Back
                  </Link>
                </div>
              </div>

              <div className="customscroll">
                <table className="table ranktable">
                  <thead>
                    <tr>
                      <th>First Opponent</th>
                      <th>First Opponent points</th>
                      <th>Second Opponent</th>
                      <th>Second Opponent points</th>
                      <th>Winner</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((item, key) => (
                        <tr key={key}>
                          <td>{item.first_opponent}</td>
                          <td>{item.total_points_first_member}</td>
                          <td>{item.second_opponent}</td>
                          <td>{item.total_points_second_member}</td>
                          <td>
                            {item.winner_user && item.winner_user}
                            {!item.winner_user && <span>Tie</span>}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowAllTypeH2H;
